import _Cookie from './cookie';
import _API from './api';
import _URL from './url';
import moment from 'moment';



const setJson = function (name, obejct = null) {
  if (obejct === null) {
    console.warn('object in require');
    return
  }
  sessionStorage[name] = JSON.stringify(obejct);
  return
}
const getJson = function (name) {
  if (sessionStorage[name]) {
    return JSON.parse(sessionStorage[name]);
  } else {
    return undefined
  }
}


//传入文件后缀名，如果是非照片类型，则返回false
const isImg = function (item) {
  const fileType = [".pdf", ".doc", "docx", ".xls", ".xlsx", ".bmp"];
  if (fileType.indexOf(item) != -1) {
    return false;
  } else {
    return true;
  }
}

const getAuth = function (data) {
  if (_Cookie.get('authback')) {
    return _Cookie.get('authback');
  } else {
    return null
  }
};

const findAuth = function (arr, authName) {
  let flage = false;
  if (arr.length) {
    flage = arr.find(x => x === authName);
  }
  return flage
}

const setAuth = function (name, obj = {}) {
  let authObject = getAuthObject();
  authObject[name].forEach(function (i, index, arr) {
    let key = i.split('.')[1];
    obj[key] = true
  });
  return obj
}

const IsUrl = function (urlString) {
  if (urlString != "") {
    let reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
    if (!reg.test(urlString)) {
      console.log('不通过')
      return false
    } else {
      return true
    }
  } else {
    console.log('Is Empyte!');
    return false
  }
}


const timeFormat = function (etime, stime) {
  //精确到分
  let st = moment(stime).format("YYYY-MM-DD HH:mm");
  let et = moment(etime).format("YYYY-MM-DD HH:mm");
  // console.log(stime,st,et,"time--");
  let time = moment(et).valueOf() - moment(st).valueOf(); //时间戳
  let calcDay = 0,
    calcHours = 0,
    calcMi = 0;
  let calctime = time / 1000 / 60 / 60; //换算为小时
  // console.log(calctime,"小时");
  let calcHs = Math.floor(calctime); //向下取整
  let calcT = calcHs / 24; //天数
  let calcTimeStr = calctime.toString(); //小时转换为字符串后取分
  let calcTstr = calcT.toString(); //天数转换为字符串后取小时
  if (Math.floor(calcT)) { //大于1天
    calcDay = Math.floor(calcT); //天数
    if (calcTstr.indexOf('.') > 0) {
      let hour = calcTstr.substr(calcTstr.indexOf('.')) * 24
      calcHours = Math.floor(hour); //小时
    };
    if (calcTimeStr.indexOf('.') > 0) {
      calcMi = parseInt(calcTimeStr.substr(calcTimeStr.indexOf('.')) * 60) //分钟
    }
    return calcDay + ' 天 ' + calcHours + ' 小时 ' + calcMi + ' 分钟 '
  } else if (calctime < 24) { //小于1天
    if (calcTstr.indexOf('.') > 0) {
      let hour = calcTstr.substr(calcTstr.indexOf('.')) * 24
      calcHours = Math.floor(hour); //小时
    };
    if (calcTimeStr.indexOf('.') > 0) {
      calcMi = parseInt(calcTimeStr.substr(calcTimeStr.indexOf('.')) * 60) //分钟
    }
    return calcHours + ' 小时 ' + calcMi + ' 分钟 '
  } else if (calctime < 1) { //小于1小时
    if (calcTimeStr.indexOf('.') > 0) {
      calcMi = parseInt(calcTimeStr.substr(calcTimeStr.indexOf('.')) * 60) //分钟
    }
    return calcMi + ' 分钟 '
  }



}
const formatTime = function (calc) {
  let s = Math.floor((calc / 1000) % 60);
  let m = Math.floor((calc / 1000 / 60) % 60);
  let h = Math.floor((calc / 1000 / 60 / 60) % 24);
  let d = Math.floor((calc / 1000 / 60 / 60 / 24))
  return `${d}` + '天' + `${h}` + '时' + `${m}` + '分'
}
const matchFileSuffixType =
  function (fileName) {
    // 后缀获取
    var suffix = ''
    // 获取类型结果
    var result = ''
    try {
      var flieArr = fileName.split('.')
      suffix = flieArr[flieArr.length - 1]
    } catch (err) {
      suffix = ''
    }
    // fileName无后缀返回 false
    if (!suffix) {
      result = false
      return result
    }
    // 图片格式
    var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
    // 进行图片匹配
    result = imglist.some(function (item) {
      return item == suffix
    })
    if (result) {
      result = 'image'
      return result
    }
    // 匹配txt
    var txtlist = ['txt']
    result = txtlist.some(function (item) {
      return item == suffix
    })
    if (result) {
      result = 'txt'
      return result
    }
    // 匹配 excel
    var excelist = ['xls', 'xlsx']
    result = excelist.some(function (item) {
      return item == suffix
    })
    if (result) {
      result = 'excel'
      return result
    }
    // 匹配 word
    var wordlist = ['doc', 'docx']
    result = wordlist.some(function (item) {
      return item == suffix
    })
    if (result) {
      result = 'word'
      return result
    }
    // 匹配 pdf
    var pdflist = ['pdf']
    result = pdflist.some(function (item) {
      return item == suffix
    })
    if (result) {
      result = 'pdf'
      return result
    }
    // 匹配 ppt
    var pptlist = ['ppt']
    result = pptlist.some(function (item) {
      return item == suffix
    })
    if (result) {
      result = 'ppt'
      return result
    }
    // 匹配 视频
    var videolist = ['mp4', 'm2v', 'mkv']
    result = videolist.some(function (item) {
      return item == suffix
    })
    if (result) {
      result = 'video'
      return result
    }
    // 匹配 音频
    var radiolist = ['mp3', 'wav', 'wmv']
    result = radiolist.some(function (item) {
      return item == suffix
    })
    if (result) {
      result = 'radio'
      return result
    }
    // 其他 文件类型
    result = 'other'
    return result
  }
const fileSizeTrans = function (size) {
  var data = "";
  if (size < 0.1 * 1024) { //如果小于0.1KB转化成B  
    data = size.toFixed(2) + "B";
  } else if (size < 0.1 * 1024 * 1024) { //如果小于0.1MB转化成KB  
    data = (size / 1024).toFixed(2) + "KB";
  } else if (size < 0.1 * 1024 * 1024 * 1024) { //如果小于0.1GB转化成MB  
    data = (size / (1024 * 1024)).toFixed(2) + "MB";
  } else { //其他转化成GB  
    data = (size / (1024 * 1024 * 1024)).toFixed(2) + "GB";
  }
  var sizestr = data + "";
  var len = sizestr.indexOf("\.");
  var dec = sizestr.substr(len + 1, 2);
  if (dec == "00") { //当小数点后为00时 去掉小数部分  
    return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
  }
  return sizestr;
}

const getPhone = function (tel) {
  let pat = /(\d{3})\d*(\d{4})/
  let b = tel.replace(pat, '$1****$2');
  return b;
}
export default {
  timeFormat,
  formatTime,
  setJson,
  getJson,
  getAuth,
  findAuth,
  setAuth,
  IsUrl,
  matchFileSuffixType,
  fileSizeTrans,
  getPhone,
  isImg
}